import { RankingQuestion } from '../../../types/Question';

// <select
//   label="Q11"
//   minRanks="3"
//   optional="1"
//   unique="none,cols"
//   uses="ranksort.4">
//   <title>New Rank Sort Question</title>
//   <comment>Click or drag each item into a rank position.</comment>
//   <row label="r1">Item 1</row>
//   <row label="r2">Item 2</row>
//   <choice label="ch1">Label 1</choice>
//   <choice label="ch2">Label 2</choice>
// </select>
/**
 * Export question as XML-precursor data type.
 *
 * @export
 * @param {RankingQuestion} question
 * @return {*}
 */
export default function toXmlType(question: RankingQuestion) {
  const xmlJSData = {
    select: {
      _attributes: {
        label: `Q${question.id}`,
        minRanks: `${question.ranking_count}`,
        unique: 'none,cols',
        shuffle: 'rows,choices',
        uses: 'ranksort.4',
      },
      title: question.title,
      choice: [
        ...Array.from(Array(question.ranking_count).keys()).map((i) => {
          return {
            _attributes: {
              label: `ch${i + 1}`,
              value: `${i + 1}`,
            },
            _text: `${i + 1}`,
          };
        }),
      ],
      row: [
        ...question.options.map((o) => {
          return {
            _attributes: {
              label: `r${o.id}`,
              value: `${o.id}`,
            },
            _text: o.name,
          };
        }),
      ],
    },
  };
  return xmlJSData;
}
